import { api } from "./client";

export const signin = async (data) => {
  const response = await api.post(`/auth/login`, {
    email: data.email,
    password: data.password,
  });
  return response.data;
};

export const register = async (data) => {
  const response = await api.post(`/auth/register`, data);
  return response.data;
};

export const self = async () => {
  const response = await api.get(`/auth/me`);
  return response.data;
};

export const logout = async () => {
  return api.post(`/auth/logout`);
};

export const getFightByID = async (fightID) => {
  const response = await api.get(`/fights/details/${fightID}`);
  return response.data;
};
export const getFightVotes = async (id) => {
  const response = await api.get(`/votes/${id}`);
  return response.data;
};

export const voteForFight = async ({ id, playerId, voteType }) => {
  const body = voteType === "DRAW" ? { voteType: "DRAW" } : { playerId };
  const response = await api.post(`/votes/${id}`, body);
  return response.data;
};

export const removeFightVote = async ({ id }) => {
  const response = await api.delete(`/votes/${id}`);
  return response.data;
};

export const rateFight = async ({ id, rating }) => {
  const response = await api.post(`/ratings/${id}`, { rating });
  return response.data;
};

export const removeFightRating = async ({ id }) => {
  const response = await api.delete(`/ratings/${id}`);
  return response.data;
};

// Comments
export const getFightComments = async (id) => {
  const response = await api.get(`/comments/${id}`);
  return response.data;
};

export const addFightComment = async ({ id, text, parentCommentId = null }) => {
  const response = await api.post(`/comments/${id}`, {
    text,
    parentCommentId,
  });
  return response.data;
};
